import {useState, useEffect} from 'react'
import {
  useNavigate
} from "react-router-dom";
import {
	Container,
	TextField,
	Grid,
	Typography,
	Paper,
	Link
} from '@mui/material'
import {
	LoadingButton
} from '@mui/lab'
import ExitToAppRoundedIcon from '@mui/icons-material/ExitToAppRounded';
import UserService from '../services/UserService'
import AuthContext from '../providers/AuthProvider'
import ClientContext from '../providers/CurrentClientProvider'
import ClientService from '../services/ClientService';
import { identify, Identify, setUserId } from '@amplitude/analytics-browser';
import { handleTrackError, trackEvent, TrackableEvent, trackEventFromObject } from '../services/AmplitudeService';

function NotLogin(props) {
	const [email, setEmail] = useState('')
	const [password, setPassword] = useState('') 
	const [errors, setErrors] = useState({})
	const [loging, setLoging] = useState(false)
	const navigate = useNavigate()
	const auth = AuthContext.useAuth()
	const selectedClient = ClientContext.useClient()

	useEffect(() => {
		document.title = 'Retail ORBIT: Login'

		resetError()
	}, [])

	function handleEmail(e) {
		setEmail(e.target.value)
		resetError()
	}

	function handlePassword(e) {
		setPassword(e.target.value)
		resetError()
	}

	function resetError() {
		setErrors({
			email: false,
			email_message: '',
			password: false,
			password_message: '',
		})
	}

	async function login() {
		try{
			if( !email.match(/.+?@.+?/) ) {
				setErrors({
					...errors,
					email: true,
					email_message: 'Please enter the correct email'
				})
				return
			}
			if( !password ) {
				setErrors({
					...errors,
					password: true,
					password_message: 'Please enter password'
				})
				return
			}
			setLoging(true)
			const _user = await UserService.login(email, password, true)
			auth.login(_user)

			let client
			if (!_user.client) {
				client = await UserService.getSingleClient()
			} else {
				client = _user.client
			}

			// if user roles array contains object with "name" Admin, set isAdmin to true + other roles
			let isAdmin = false
			let isAffiliate = false
			let isClient = false
			let isUser = false

			_user.roles.forEach(role => {
				if(!isAdmin && role.name === 'Admin') {
					isAdmin = true
				}
				if(!isAffiliate && role.name === 'Affiliate') {
					isAffiliate = true
				}
				if(client && !isClient && role.name === 'Client') {
					isClient = true
				}
				if(!isUser && role.type === 'USER') {
					isUser = true
				}
			})

			// Analytics
			try {
				setUserId(_user.id);

				// Identify in amplitude for tracking
				let identifyEvent = new Identify();
				identifyEvent.set('userId', _user.id);
				identifyEvent.set('email', _user.email);
				identifyEvent.set('name', _user.first_name + ' ' + _user.last_name);
				identifyEvent.set('isAdmin', isAdmin);
				identifyEvent.set('isAffiliate', isAffiliate);
				identifyEvent.set('isClient', isClient);

				identify(identifyEvent);

				let trackableEvent = new TrackableEvent({
					pageName: 'Auth',
					clientCode: isClient ? client?.ClientCode : null,
					action: 'Login',
					additionalMetadata: {
						email: _user.email,
						isAdmin,
						isAffiliate: !isAdmin ? isAffiliate : false,
						isClient: !isAdmin ? isClient : false,
						isUser
					}
				});

				trackEventFromObject(trackableEvent);
			} catch (e) {
				console.log("Something went wrong with June");
				console.log(e)
			}

			// if client is not null then they only have one client so auto select it
			if (_user.client) {
				selectedClient.setClient(_user.client)
			}

			setLoging(false)
			navigate('/users')
		} catch(e) {
			console.log(e)
			if (e.response?.data) {
				setErrors({
					...errors,
					password: true,
					password_message: e.response.data.message
				})

				handleTrackError({ error: e, pageName: 'Login', additionalMetadata: { email } })
			} else {
				handleTrackError({ error: e, pageName: 'Login', overrideMessage: 'Failed to login', additionalMetadata: { email } })
			}
			setLoging(false)
		}
	}

	return <>
		<Container fixed>
			<Grid container sx={{pt: 20}}>
				<Grid item xs={0} sm={2} lg={3}></Grid>
				<Grid item xs={12} sm={8} lg={6}>
					<Paper sx={{p: 3, pb:4}}>
						<Typography variant="h5">
							Retail ORBIT®
						</Typography>
						<Typography variant="subtitle1" sx={{mb:3}}>
							Login to your account
						</Typography>
						<TextField 
							fullWidth
							label="Email Address"
							value={email}
							name="email"
							onChange={handleEmail}
							error={errors.email}
							helperText={errors.email_message}
							sx={{backgroundColor: 'white'}}
						/>
						<TextField 
							fullWidth
							label="Password"
							type='password'
							value={password}
							name="password"
							onChange={handlePassword}
							error={errors.password}
							helperText={errors.password_message}
							sx={{mt: 2, backgroundColor: 'white'}}
						/>
						<LoadingButton
							variant="contained"
							loading={loging}
							color='primary'
							sx={{mt: 2, mb: 2}}
							fullWidth
							size="large"
							onClick={login}
							startIcon={<ExitToAppRoundedIcon />}
						>
							Sign In
						</LoadingButton>
						<Link
							href="forgot-password"
							underline="hover"
							sx={{ textTransform: 'uppercase'}}
						>
							forgot password?
						</Link>
					</Paper>
				</Grid>
			</Grid>
		</Container>
	</>
}

export default NotLogin